import { FormControl, MenuItem, Select } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Loader from 'react-loader-spinner';
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';

import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars';
import Alert from 'react-s-alert';
import SVG from 'react-inlinesvg';
import Media from 'react-media';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';
import * as yup from 'yup';
import {
  get_all_subcategoryIn_menuSetup,
  add_category_menu_setup,
  edit_category_menu_setup,
} from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';
import { update_ordering_subscription_taxes } from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';
import { AmealioLoader } from '../../../../../../Loader/AmealioLoader';
import { AddButtonIconComponent } from '../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent';
import { NewInputText } from '../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import { MobileTopHeader } from '../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader';
import { SliderReusableComponent } from '../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent';
import { BackLogoIconButton } from '../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText';
import { ReusableOnboardingButton } from '../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { TopTextReusableComponent } from '../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import { ToggleButtonWithYesNo } from '../../../AllButton/ToggleButtonReuse';
import TaxesSurCharges, { AddSurchargesModel } from './TaxesSurCharges';
import { PRODUCTCLASSIFICATION } from '../../../../../../../enums/GlobalEnums';

const AddCategories = (props) => {
  let history = useHistory();

  const { transcript } = useSpeechRecognition();

  const [showAddedTaxes, setShowAddedTaxes] = useState(true);
  //const [file, setFile] = useState(null);
  const [WithTaxes, setWithTaxes] = useState(false);
  const [active, setActive] = useState('PERCENTAGE');
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState('');
  const [utterancesVoice, setUtterancesVoice] = useState([]);
  const [utterancesVoiceText, setUtterancesVoiceText] = useState('');
  // const uploadImage = (e) => {
  //   setFile(URL.createObjectURL(e.target.files[0]));
  // };
  const handleWithTaxes = () => {
    setWithTaxes(!WithTaxes);
  };

  const takeToDashboard = () => {
    if (history.location.pathname.includes('catalog')) {
      history.push(
        '/casual-fine-dining/menusetup/selectmenu/selectedcategories'
      );
    } else if (history.location.pathname.includes('verifiedVendor')) {
      history.push('/selectedcategories');
    } else if (
      history.location.pathname.includes('fastfood/menusetup/addcategory')
    ) {
      history.push('/fastfood/menusetup');
    } else if (
      history.location.pathname.includes('multi-service/menusetup/addcategory')
    ) {
      history.push('/multi-service/menusetup');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      // history.push("/categorydashboard");
      history.push('/menusetup-dashboard');
    } else {
      history.push('/casual-fine-dining/menusetup');
    }
  };

  const handleNextStep = (e) => {
    setStep(e);
  };

  /*******************************
   * Add Utterances Voice Action
   ******************************/
  const handleKeyUttrences = (event) => {
    if (event.key === 'Enter') {
      let utterancesVoiceTextVr = utterancesVoiceText;
      let utterancesVoiceArr = utterancesVoice;
      if (utterancesVoiceTextVr === '') {
        errors.utterancesVoiceTextVr = 'Utterances voice is Required';
        setErrors({
          errors: errors,
        });
      } else if (
        utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
      ) {
        alert('Utterances voice already exits');
      } else {
        utterancesVoiceArr.push(utterancesVoiceTextVr);
        setUtterancesVoice(utterancesVoiceArr);
        formik.setFieldValue('utterancesVoice', utterancesVoiceArr);
        setUtterancesVoiceText('');
      }
    }
  };

  const addUtterancesVoiceAction = (e) => {
    e.preventDefault();
    let utterancesVoiceTextVr = utterancesVoiceText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === '') {
      errors.utterancesVoiceTextVr = 'Utterances voice is Required';
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert('Utterances voice already exits');
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue('utterancesVoice', utterancesVoiceArr);
      setUtterancesVoiceText('');
    }
  };

  const addUtterancesVoiceActionMic = (valueText) => {
    //e.preventDefault();
    let utterancesVoiceTextVr = valueText;
    let utterancesVoiceArr = utterancesVoice;
    if (utterancesVoiceTextVr === '') {
      errors.utterancesVoiceTextVr = 'Uterances voice is Required';
      setErrors({
        errors: errors,
      });
    } else if (
      utterancesVoiceArr.some((diner) => diner === utterancesVoiceTextVr)
    ) {
      alert('Utterances voice already exits');
    } else {
      utterancesVoiceArr.push(utterancesVoiceTextVr);
      setUtterancesVoice(utterancesVoiceArr);
      formik.setFieldValue('utterancesVoice', utterancesVoiceArr);
      setUtterancesVoiceText('');
    }
  };

  /*************************************
   * @DESC Utterances Voice Change Handlers
   ************************************/
  const onUtterancesVoiceChangeHandler = (e) => {
    setUtterancesVoiceText(e.target.value);
  };
  /*************************************
   * @DESC Remove utterancesVoice Change Handlers
   ************************************/
  const removeUtterancesVoiceAction = (indexId) => (e) => {
    var data = [...utterancesVoice];
    data.splice(indexId, 1);
    setUtterancesVoice(data);
    formik.setFieldValue('utterancesVoice', data);
  };

  /*******************************
   * Add Keywords Action
   ******************************/
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      let keywordsTextVr = keywordsText;
      let keywordsArr = keywords;
      if (keywordsTextVr === '') {
        errors.keywordsTextVr = 'Keywords is Required';
        setErrors({
          errors: errors,
        });
      } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
        alert('Keywords Already Exits');
      } else {
        keywordsArr.push(keywordsTextVr);
        setKeywords(keywordsArr);
        setKeywordsText('');
      }
    }
  };

  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === '') {
      errors.keywordsTextVr = 'Keywords is Required';
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert('Keywords Already Exits');
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText('');
    }
  };

  const addKeywordsActionMic = (valueText) => {
    //e.preventDefault();
    let keywordsTextVr = valueText;
    let keywordsArr = keywords;
    if (keywordsTextVr === '') {
      errors.keywordsTextVr = 'Keywords is Required';
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert('Keywords Already Exits');
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText('');
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };

  const [categoryClassification, setClassification] = useState(
    props?.categoryClassification
  );

  const [allCategoryClassifications, setAllCategoryClassifications] = useState(
    props?.get_catgory_Classification
  );

  const [count, setCount] = useState(1);

  const onClickNext = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const Capitalize = (str, name) => {
    return formik.setFieldValue(
      name,
      str.charAt(0).toUpperCase() + str.slice(1)
    );
  };

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formik.setFieldValue(name, str.join(' '));
  };

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let catNameElement = document.getElementById('name');
      catNameElement.focus();
    } else if (formik.errors && formik.errors.category_classification) {
      let categoryClassficationElement = document.getElementById(
        'category_classification'
      );
      categoryClassficationElement.focus();
    } else if (formik.errors && formik.errors.product_classification) {
      let productClassficationElement = document.getElementById(
        'product_classification'
      );
      productClassficationElement.focus();
    }
  }, [count]);

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
      category_classification: '',
      product_classification: 'Food',
      charges: [],
      keywords: [],
      utterancesVoice: [],
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, 'Must be 128 characters or less')
        .required('Category name is required'),
      category_classification: yup
        .string()
        .required('Please select category classification'),
      product_classification: yup
        .string()
        .required('Please select product classification'),
    }),
    onSubmit: (values) => {
      formik.setFieldValue('keywords', keywords);
      formik.setFieldValue('utterancesVoice', utterancesVoice);
      handleNextStep(2);
    },
  });

  const [activeProductClassification, setActiveProductClassification] =
    useState('61b6d3d8cfe1015e07404c18');
  const onChangeProductClassification = (data) => {
    formik.setFieldValue('product_classification', data.title);
    setActiveProductClassification(data._id);
    props.get_all_subcategoryIn_menuSetup(data._id);
  };

  const onEditSuccess = (catId, data) => {
    let totlaChange = data?.price_include_tax
      ? data?.charges
      : props.orderingTaxesData?.tax_values;
    let take_away_charges = [];
    let curb_side_charges = [];
    let dine_in_charges = [];
    let skip_line_charges = [];
    let catering_banquet_charges = [];
    let home_delivery_charges = [];
    /*******************
     * @DESC Take Away
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].take_away !== undefined &&
        totlaChange[i].take_away !== null
      ) {
        take_away_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].take_away,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Curb Side
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].curb_side !== undefined &&
        totlaChange[i].curb_side !== null
      ) {
        curb_side_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].curb_side,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }

    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].skip_line !== undefined &&
        totlaChange[i].skip_line !== null
      ) {
        skip_line_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].skip_line,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Dine In
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].dine_in_order !== undefined &&
        totlaChange[i].dine_in_order !== null
      ) {
        dine_in_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].dine_in_order,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Catering Banquet
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].catering_banquet !== undefined &&
        totlaChange[i].catering_banquet !== null
      ) {
        catering_banquet_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].catering_banquet,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    /*******************
     * @DESC Home Delivery
     ********************/
    for (let i = 0; i < totlaChange.length; i++) {
      if (
        totlaChange[i].home_delivery !== undefined &&
        totlaChange[i].home_delivery !== null
      ) {
        home_delivery_charges.push({
          _id: totlaChange[i]._id,
          name: totlaChange[i].tax_name,
          value: totlaChange[i].home_delivery,
          flag: totlaChange[i].tax_value,
          flatCharges: totlaChange[i].flatCharges,
        });
      }
    }
    const token = props.auth.user.accessToken;
    let formData = {
      category: {
        charges: totlaChange,
      },
      Items: {
        take_away: {
          sur_charges: take_away_charges,
        },
        curb_side: {
          sur_charges: curb_side_charges,
        },
        dine_in_order: {
          sur_charges: dine_in_charges,
        },
        skip_line: {
          sur_charges: skip_line_charges,
        },
        catering_banquet: {
          sur_charges: catering_banquet_charges,
        },
        home_delivery: {
          sur_charges: home_delivery_charges,
        },
      },
    };
    props.update_ordering_subscription_taxes(
      formData,
      token,
      true,
      catId,
      onSuccess(),
      (err) => onErrorTaxes(err)
    );
  };

  const onSuccess = () => {
    if (history.location.pathname.includes('catalog')) {
      history.push(
        '/casual-fine-dining/menusetup/selectmenu/selectedcategories'
      );
    } else if (history.location.pathname.includes('verifiedVendor')) {
      history.push('/selectedcategories');
    } else if (
      history.location.pathname.includes('fastfood/menusetup/addcategory')
    ) {
      history.push('/fastfood/menusetup');
    } else if (
      history.location.pathname.includes('multi-service/menusetup/addcategory')
    ) {
      history.push('/multi-service/menusetup');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/menusetup-dashboard');
    } else {
      history.push('/casual-fine-dining/menusetup');
    }
  };

  const onErrorTaxes = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const formikStepTwo = useFormik({
    initialValues: {
      test: '',
    },
    //validate,
    onSubmit: (values) => {
      let formData = {};
      formData = { ...formik.values };
      formData.price_include_tax = WithTaxes;
      formData.charges = taxValues;
      formData.menuId = props?.ActiveMenu ? props?.ActiveMenu?._id : '';

      // if (WithTaxes) {
      //   formData.price_include_tax = false;
      //   //formData.cross_selling = {};
      //   formData.charges = taxValues;
      // } else {
      //   formData.price_include_tax = true;
      //   //formData.cross_selling = {};
      //   formData.charges = taxValues;
      // }
      const token = props.auth.user.accessToken;
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2
      ) {
        let msg = 'Category edited Successfully';
        props.edit_category_menu_setup(
          props.activeCategoryData._id,
          formData,
          token,
          (catId) => onEditSuccess(catId, formData),
          msg
        );
      } else {
        props.add_category_menu_setup(formData, token, onSuccess);
      }
    },
    // handleNextStep(2);
  });

  const [addsurcharges, setAddSurcharges] = React.useState(false);
  const openAddSurcharges = () => {
    setAddSurcharges(true);
  };
  const closeAddSurcharges = () => {
    setAddSurcharges(false);
  };
  const onClickSave = () => {
    formikStepTwo.handleSubmit();
  };

  const [addNewTaxes, setAddNewTaxes] = useState([]);

  const [taxCode, setTaxCode] = useState([]);
  const [taxValues, setTaxValues] = useState([]);
  const [showSkipTheLine, setSHowSkipLine] = useState(false);
  const [showTakeAway, setShowTakeAway] = useState(true);
  const [showCurbSide, setShowCurbSide] = useState(false);
  const [showDineIn, setShowDineIn] = useState(false);
  const [showCateringBanquet, setShowCateringBanquet] = useState(false);
  const [showHomeDelivery, setShowHomeDelivery] = useState(false);

  const onChangeValue = (e, name, id) => {
    let existingData = [];

    for (let i = 0; i < taxValues.length; i++) {
      if (id === taxValues[i]._id) {
        let data = JSON.parse(JSON.stringify(taxValues[i]));
        data[name] = e;
        existingData.push(data);
      } else {
        existingData.push(taxValues[i]);
      }
    }
    setTaxValues(existingData);
  };

  const removeTax = (data) => {
    let deleteTax = taxValues.filter((item) => {
      return item._id !== data._id;
    });

    setTaxValues(deleteTax);
    let existingTaxes = [...addNewTaxes];

    existingTaxes.push(data);
    setAddNewTaxes(existingTaxes);
  };

  const onClickSaveModalData = (data) => {
    const existingTaxes = [];
    for (let i = 0; i < addNewTaxes.length; i++) {
      if (data.id === addNewTaxes[i].id) {
        setTaxValues([...taxValues, data]);
      } else {
        existingTaxes.push(addNewTaxes[i]);
      }
    }
    setAddNewTaxes(existingTaxes);
  };

  useEffect(() => {
    if (
      props &&
      props.activeCategoryData &&
      props.activeCategoryData._id &&
      props.activeCategoryData._id.length > 2
    ) {
      let data = props.activeCategoryData;
      formik.setFieldValue('name', data.name);
      if (data.keywords) {
        setKeywords(data.keywords);
      }
      if (data.utterancesVoice) {
        setUtterancesVoice(data.utterancesVoice);
      }
      formik.setFieldValue('description', data.description);
      formik.setFieldValue(
        'category_classification',
        data.category_classification
      );
      formik.setFieldValue(
        'product_classification',
        data.product_classification
      );
      // if (data.charges.length >= 1) {
      setWithTaxes(data?.price_include_tax);
      // }
    }
    props.get_all_subcategoryIn_menuSetup(activeProductClassification);
    setClassification(props?.categoryClassification);
    setAllCategoryClassifications(props?.get_catgory_Classification);
  }, []);

  useEffect(() => {
    // if (props && props.subscriptionData && props.subscriptionData.tax_values) {
    //   setTaxValues(props.subscriptionData.tax_values);
    // }

    // if (props && props.subscriptionData && props.subscriptionData.tax_code) {
    //   setTaxCode(props.subscriptionData.tax_code)
    // }

    if (
      history.location.pathname.includes('fastfood/menusetup/addcategory') ||
      (props.serviceType && props.serviceType.fast_food_dining)
    ) {
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2 &&
        props &&
        props.subscriptionDataFastFood &&
        props.subscriptionDataFastFood.tax_values
      ) {
        //let
        let taxNames = [];
        let taxData = [];
        for (
          let i = 0;
          i < props.subscriptionDataFastFood.tax_values.length;
          i++
        ) {
          taxNames[i] = props.subscriptionDataFastFood.tax_values[i].tax_name;
        }
        for (let i = 0; i < props.activeCategoryData.charges.length; i++) {
          if (taxNames?.includes(props.activeCategoryData.charges[i].name)) {
            let existingD = JSON.parse(
              JSON.stringify(props.activeCategoryData.charges[i])
            );
            existingD.tax_name =
              taxNames[props.activeCategoryData.charges[i].id];
            taxData.push(existingD);
          } else {
            taxData.push(props.activeCategoryData.charges[i]);
          }
        }

        setTaxValues(taxData);
        let id = [];
        let newTaxes = [];

        for (let i = 0; i < taxData.length; i++) {
          id.push(taxData[i].id);
        }
        for (
          let j = 0;
          j < props.subscriptionDataFastFood.tax_code.length;
          j++
        ) {
          if (!id.includes(props.subscriptionDataFastFood.tax_code[j].id)) {
            let prepData = {
              id: props.subscriptionDataFastFood.tax_code[j].id,
              tax_name: props.subscriptionDataFastFood.tax_code[j].description,
              code: props.subscriptionDataFastFood.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }
        }
        setAddNewTaxes(newTaxes);
      } else if (
        props &&
        props.subscriptionDataFastFood &&
        props.subscriptionDataFastFood.tax_values
      ) {
        let id = [];
        let newTaxes = [];

        for (
          let i = 0;
          i < props.subscriptionDataFastFood.tax_values.length;
          i++
        ) {
          id.push(props.subscriptionDataFastFood.tax_values[i].id);
        }

        for (
          let j = 0;
          j < props.subscriptionDataFastFood.tax_code.length;
          j++
        ) {
          if (!id.includes(props.subscriptionDataFastFood.tax_code[j].id)) {
            let prepData = {
              id: props.subscriptionDataFastFood.tax_code[j].id,
              tax_name: props.subscriptionDataFastFood.tax_code[j].description,
              code: props.subscriptionDataFastFood.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }

          let taxValues = [];
          if (props?.subscriptionDataFastFood?.tax_values?.length) {
            taxValues = props?.subscriptionDataFastFood?.tax_values?.filter(
              (ele) => !ele.flatCharges
            );
          }
          setTaxValues(taxValues);

          setAddNewTaxes(newTaxes);
        }
      }
    } else if (
      history.location.pathname.includes(
        'multi-service/menusetup/addcategory'
      ) ||
      (props.serviceType && props.serviceType.multi_service_business)
    ) {
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2 &&
        props &&
        props.subscriptionDataMultiServices &&
        props.subscriptionDataMultiServices.tax_values
      ) {
        //let

        let taxNames = [];
        let taxData = [];

        for (
          let i = 0;
          i < props.subscriptionDataMultiServices.tax_values.length;
          i++
        ) {
          taxNames[i] =
            props.subscriptionDataMultiServices.tax_values[i].tax_name;
        }

        for (let i = 0; i < props.activeCategoryData.charges.length; i++) {
          if (taxNames?.includes(props.activeCategoryData.charges[i].name)) {
            let existingD = JSON.parse(
              JSON.stringify(props.activeCategoryData.charges[i])
            );
            existingD.tax_name =
              taxNames[props.activeCategoryData.charges[i].id];
            taxData.push(existingD);
          } else {
            taxData.push(props.activeCategoryData.charges[i]);
          }
        }

        setTaxValues(taxData);
        let id = [];
        let newTaxes = [];

        for (let i = 0; i < taxData.length; i++) {
          id.push(taxData[i].id);
        }
        for (
          let j = 0;
          j < props.subscriptionDataMultiServices.tax_code.length;
          j++
        ) {
          if (
            !id.includes(props.subscriptionDataMultiServices.tax_code[j].id)
          ) {
            let prepData = {
              id: props.subscriptionDataMultiServices.tax_code[j].id,
              tax_name:
                props.subscriptionDataMultiServices.tax_code[j].description,
              code: props.subscriptionDataMultiServices.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }
        }
        setAddNewTaxes(newTaxes);
      } else if (
        props &&
        props.subscriptionDataMultiServices &&
        props.subscriptionDataMultiServices.tax_values
      ) {
        let id = [];
        let newTaxes = [];

        for (
          let i = 0;
          i < props.subscriptionDataMultiServices.tax_values.length;
          i++
        ) {
          id.push(props.subscriptionDataMultiServices.tax_values[i].id);
        }

        for (
          let j = 0;
          j < props.subscriptionDataMultiServices.tax_code.length;
          j++
        ) {
          if (
            !id.includes(props.subscriptionDataMultiServices.tax_code[j].id)
          ) {
            let prepData = {
              id: props.subscriptionDataMultiServices.tax_code[j].id,
              tax_name:
                props.subscriptionDataMultiServices.tax_code[j].description,
              code: props.subscriptionDataMultiServices.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }

          let taxValues = [];
          if (props?.subscriptionDataMultiServices?.tax_values?.length) {
            taxValues =
              props?.subscriptionDataMultiServices?.tax_values?.filter(
                (ele) => !ele.flatCharges
              );
          }
          setTaxValues(taxValues);

          setAddNewTaxes(newTaxes);
        }
      }
    } else {
      if (
        props &&
        props.activeCategoryData &&
        props.activeCategoryData._id &&
        props.activeCategoryData._id.length > 2 &&
        props &&
        props.subscriptionData &&
        props.subscriptionData.tax_values
      ) {
        //let

        let taxNames = [];
        let taxData = [];

        for (let i = 0; i < props.subscriptionData.tax_values.length; i++) {
          taxNames[i] = props.subscriptionData.tax_values[i].tax_name;
        }
        for (let i = 0; i < props.activeCategoryData.charges.length; i++) {
          if (taxNames?.includes(props.activeCategoryData.charges[i].name)) {
            let existingD = JSON.parse(
              JSON.stringify(props.activeCategoryData.charges[i])
            );
            existingD.tax_name =
              taxNames[props.activeCategoryData.charges[i].name];
            taxData.push(existingD);
          } else {
            taxData.push(props.activeCategoryData.charges[i]);
          }
        }
        setTaxValues(taxData);
        let id = [];
        let newTaxes = [];

        for (let i = 0; i < taxData.length; i++) {
          id.push(taxData[i].id);
        }
        for (let j = 0; j < props.subscriptionData.tax_code.length; j++) {
          if (!id.includes(props.subscriptionData.tax_code[j].id)) {
            let prepData = {
              id: props.subscriptionData.tax_code[j].id,
              tax_name: props.subscriptionData.tax_code[j].description,
              code: props.subscriptionData.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }
        }
        setAddNewTaxes(newTaxes);
      } else if (
        props &&
        props.subscriptionData &&
        props.subscriptionData.tax_values
      ) {
        let id = [];
        let newTaxes = [];

        for (let i = 0; i < props.subscriptionData.tax_values.length; i++) {
          id.push(props.subscriptionData.tax_values[i].id);
        }

        for (let j = 0; j < props.subscriptionData.tax_code.length; j++) {
          if (!id.includes(props.subscriptionData.tax_code[j].id)) {
            let prepData = {
              id: props.subscriptionData.tax_code[j].id,
              tax_name: props.subscriptionData.tax_code[j].description,
              code: props.subscriptionData.tax_code[j].code,
              tax_value: 'PERCENTAGE',
              take_away: 0,
              curb_side: 0,
              dine_in_order: 0,
              catering_banquet: 0,
              home_delivery: 0,
              skip_line: 0,
            };
            newTaxes.push(prepData);
          }

          let taxValues = [];
          if (props?.subscriptionData?.tax_values?.length) {
            taxValues = props?.subscriptionData?.tax_values?.filter(
              (ele) => !ele.flatCharges
            );
          }
          setTaxValues(taxValues);

          setAddNewTaxes(newTaxes);
        }
      }
    }
    setClassification(props?.categoryClassification);
    setAllCategoryClassifications(props?.get_catgory_Classification);
  }, [
    props.subscriptionData,
    props.activeCategoryData,
    props.subscriptionDataFastFood,
    props.serviceType,
    props.categoryClassification,
    props?.get_catgory_Classification,
  ]);

  useEffect(() => {
    if (
      history.location.pathname.includes('fastfood/menusetup/addcategory') ||
      (props.serviceType && props.serviceType.fast_food_dining)
    ) {
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.take_away &&
        props.servicesEnabledFastFood.take_away.value
      ) {
        setShowTakeAway(true);
      }

      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.self_serve &&
        props.servicesEnabledFastFood.self_serve.value
      ) {
        setSHowSkipLine(true);
      }

      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.cubside_delivery &&
        props.servicesEnabledFastFood.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }

      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.dine_in_order &&
        props.servicesEnabledFastFood.dine_in_order.value
      ) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.catering_banquet &&
        props.servicesEnabledFastFood.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabledFastFood &&
        props.servicesEnabledFastFood.home_delivery &&
        props.servicesEnabledFastFood.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    } else if (
      history.location.pathname.includes(
        'multi-service/menusetup/addcategory'
      ) ||
      (props.serviceType && props.serviceType.multi_service_business)
    ) {
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.take_away &&
        props.servicesEnabledMultiService.take_away.value
      ) {
        setShowTakeAway(true);
      }

      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.self_serve &&
        props.servicesEnabledMultiService.self_serve.value
      ) {
        setSHowSkipLine(true);
      }

      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.cubside_delivery &&
        props.servicesEnabledMultiService.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }

      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.dine_in_order &&
        props.servicesEnabledMultiService.dine_in_order.value
      ) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.catering_banquet &&
        props.servicesEnabledMultiService.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabledMultiService &&
        props.servicesEnabledMultiService.home_delivery &&
        props.servicesEnabledMultiService.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    } else {
      if (
        props.servicesEnabled &&
        props.servicesEnabled.take_away &&
        props.servicesEnabled.take_away.value
      ) {
        setShowTakeAway(true);
      }

      // if (props.checkSkipLine && props.checkSkipLine.fast_food_dining) {
      //   setSHowSkipLine(true);
      // }

      if (
        props.servicesEnabled &&
        props.servicesEnabled.cubside_delivery &&
        props.servicesEnabled.cubside_delivery.value
      ) {
        setShowCurbSide(true);
      }

      if (
        props.servicesEnabled &&
        props.servicesEnabled.dine_in_order &&
        props.servicesEnabled.dine_in_order.value
      ) {
        setShowDineIn(true);
      }
      if (
        props.servicesEnabled &&
        props.servicesEnabled.catering_banquet &&
        props.servicesEnabled.catering_banquet.value
      ) {
        setShowCateringBanquet(true);
      }
      if (
        props.servicesEnabled &&
        props.servicesEnabled.home_delivery &&
        props.servicesEnabled.home_delivery.value
      ) {
        setShowHomeDelivery(true);
      }
    }
    setClassification(props?.categoryClassification);
    setAllCategoryClassifications(props?.get_catgory_Classification);
  }, [
    props.servicesEnabled,
    props.servicesEnabledFastFood,
    props.servicesEnabledMultiService,
    props.serviceType,
    props?.categoryClassification,
    props?.get_catgory_Classification,
  ]);

  const checkIfBrowserSupported = () => {
    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
      return alert('Not supported by your browser');
    } else {
      SpeechRecognition.startListening();
    }
  };

  useEffect(() => {
    if (transcript) {
      addUtterancesVoiceActionMic(transcript);
    }
  }, [transcript]);

  return (
    <>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className={`mobile-pb-70 p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6  new-subscription-onboarding-component ${
                  !props.dash && `onboarding_process_screen_left`
                }`}
              >
                {!props.dash && (
                  <>
                    <Media query="(min-width: 992px)">
                      <div className="col-12">
                        <BackLogoIconButton
                          displayBackText={true}
                          displayArrow={true}
                          //backButtonClicked={"/casual-fine-dining/menusetup"}
                          backButtonClicked={() => takeToDashboard()}
                          notDisplaProgressBar={true}
                          workWithLinkORClick={true}
                        />
                      </div>
                    </Media>
                    <Media query="(max-width: 991px)">
                      <MobileTopHeader
                        link={true}
                        onLink={'/casual-fine-dining/menusetup'}
                      />
                    </Media>
                  </>
                )}
                <div
                  className={`${
                    !props.dash && `onboarding_process_screen-button-map`
                  }`}
                >
                  <Form className="mb-4">
                    {step === 1 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="doing">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>
                            <li className="todo">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li>
                          </ul>
                        </div>
                        <div className="mb-4">
                          <TopTextReusableComponent
                            headingText={
                              props &&
                              props.activeCategoryData &&
                              props.activeCategoryData._id &&
                              props.activeCategoryData._id.length > 2
                                ? 'Edit Category'
                                : 'New Category'
                            }
                            headingParagraph="Manage your food items"
                          />
                        </div>
                        <Form.Label className="f14-500 mb-3">
                          Add Menu Category
                        </Form.Label>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              controlClass={'name'}
                              labelText="Category Name"
                              extraClass={`mb-1 w-100 ${
                                formik.errors.name && formik.touched.name
                                  ? 'enError'
                                  : ''
                              }`}
                              name="name"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                titleCase(e.target.value, 'name')
                              }
                              value={formik.values.name}
                              onFocusOut={formik.handleBlur}
                            />
                            {formik.errors.name && formik.touched.name ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.name}
                              </div>
                            ) : null}
                          </Col>
                          <Col md={8} className="mt-3">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-12">
                                  <Paper
                                    component="form"
                                    className="enSearch2 d-flex"
                                  >
                                    <InputBase
                                      placeholder="Utterances for Voice"
                                      inputProps={{
                                        'aria-label': 'Add Utterances',
                                      }}
                                      name="utterancesVoiceText"
                                      onChange={onUtterancesVoiceChangeHandler}
                                      value={utterancesVoiceText}
                                      onKeyPress={(e) => {
                                        if (e.which == 13) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onKeyDown={handleKeyUttrences}
                                      className="w-100 px-3"
                                    />
                                    <IconButton
                                      type="button"
                                      aria-label="Add Utterances"
                                      onClick={SpeechRecognition.startListening}
                                    >
                                      <KeyboardVoiceIcon />
                                    </IconButton>
                                  </Paper>
                                  {/* <NewInputText
                                    extraClass="mb-1"
                                    name="utterancesVoiceText"
                                    onChange={onUtterancesVoiceChangeHandler}
                                    value={utterancesVoiceText}
                                    labelText="Utterances for Voice"
                                    inputType="text"
                                    onKeyPress={(e) => {
                                      if (e.which == 13) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onKeyDown={handleKeyUttrences}
                                  /> */}
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.utterancesVoiceText !== ''
                                      ? errors.utterancesVoiceText
                                      : '* Manage the utterances for the food item'}
                                  </div>
                                  <div className="opacity5 f10-400">
                                    * Manage the utterances for the Categories
                                    {/* <p>
                                  {transcript
                                    ? transcript
                                    : "Start listening for transcript"}
                                </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={4} xs={5} className="mt-3">
                            {/* <Button
                              variant="secondary"
                              onClick={SpeechRecognition.startListening}
                            >
                            </Button> */}
                            <div
                              className="f10-400 mt-2"
                              style={{ color: '#2096F3' }}
                            >
                              <AddButtonIconComponent
                                buttonText="Add Utterances"
                                onClick={addUtterancesVoiceAction}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          </Col>
                          {utterancesVoice && utterancesVoice.length > 0 ? (
                            <Col md={12} className="mt-3">
                              <div className="col-12 p-0 onboarding-restaurant-details-margin">
                                <div className="row enChipBox border-0">
                                  {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                                  {utterancesVoice &&
                                    utterancesVoice.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeUtterancesVoiceAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require('../../../../../../../assets/images/UserManagement/close.svg')}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {/* </Scrollbars> */}
                                </div>
                              </div>
                            </Col>
                          ) : (
                            ''
                          )}
                          {/* <Col md={8} className="mt-3">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-7">
                                  <NewInputText
                                    extraClass="mb-1"
                                    name="keywordsText"
                                    onChange={onKeywordsChangeHandler}
                                    value={keywordsText}
                                    labelText="Keywords"
                                  />
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.keywordsText}
                                  </div>
                                </div>
                                <div className="col-5">
                                  <AddButtonIconComponent
                                    buttonText="Add More Keywords"
                                    onClick={addKeywordsAction}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={8} xs={7} className="mt-3">
                            <div className="col-12 p-0 onboarding-restaurant-details-margin">
                              <div className="">
                                <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                >
                                  {keywords &&
                                    keywords.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeKeywordsAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require("../../../../../../../assets/images/UserManagement/close.svg")}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </Scrollbars>
                              </div>
                              <div className="opacity5 f10-400">
                                * Manage the utterances for the Categories
                                {/* <p>
                                  {transcript
                                    ? transcript
                                    : "Start listening for transcript"}
                                </p> *
                              </div>
                            </div>
                          </Col>
                          <Col md={4} xs={5} className="mt-3">
                            <Button
                              variant="secondary"
                              //onClick={SpeechRecognition.startListening}
                              onClick={() => checkIfBrowserSupported()}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  left: "50px",
                                }}
                              >
                                <AddButtonIconComponent
                                  onClick={addKeywordsAction}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                />
                              </div>
                              <SVG
                                src={require("../../../../../../../assets/images/UserManagement/microphone.svg")}
                                width="22px"
                                height="30px"
                              />
                            </Button>
                            <div
                              className="f10-400 mt-2"
                              style={{ color: "#2096F3" }}
                            >
                              Add Utterances
                            </div>
                            <FormControl
                              variant="outlined"
                              className="mt-2"
                              fullWidth
                            >
                              <Select
                                labelId="demo-customized-select-label"
                                fullWidth
                                id="demo-customized-select"
                                value={"EN -English"}
                                // onChange={handleChange}
                              >
                                <MenuItem value="EN -English">
                                  EN -English
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Col> */}
                        </Row>
                        <Row>
                          <Col md={10} className="mt-3">
                            <div className=" onboarding-restaurant-details-margin">
                              <div className="row align-items-center">
                                <div className="col-9">
                                  <NewInputText
                                    extraClass="mb-1"
                                    name="keywordsText"
                                    onChange={onKeywordsChangeHandler}
                                    value={keywordsText}
                                    labelText="Keywords"
                                    inputType="text"
                                    onKeyPress={(e) => {
                                      if (e.which == 13) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onKeyDown={handleKeyDown}
                                  />
                                  <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                                    {errors.keywordsText}
                                  </div>
                                  <div className="opacity5 f10-400">
                                    (Your keywords for the food item will help
                                    people find the item with ease )
                                  </div>
                                </div>
                                <div className="col-3">
                                  <AddButtonIconComponent
                                    buttonText="Add Keywords"
                                    onClick={addKeywordsAction}
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={8} className="mt-3">
                            {keywords && keywords.length > 0 ? (
                              <div className="col-12 p-0 onboarding-restaurant-details-margin">
                                <div className="row enChipBox border-0">
                                  {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                                  {keywords &&
                                    keywords.map((data, index) => {
                                      return (
                                        <div className="mb-3 mr-3" key={index}>
                                          <div className="keywords_button">
                                            <p>{data}</p>
                                            <span
                                              className="ml-2"
                                              onClick={removeKeywordsAction(
                                                index
                                              )}
                                            >
                                              <SVG
                                                src={require('../../../../../../../assets/images/UserManagement/close.svg')}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  {/* </Scrollbars> */}
                                </div>
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Description *"
                              extraClass="mb-1 w-100"
                              multiline={true}
                              rows="4"
                              name="description"
                              //onChange={formik.handleChange}
                              onChange={(e) =>
                                Capitalize(e.target.value, 'description')
                              }
                              value={formik.values.description}
                            />
                          </Col>
                        </Row>
                        {/* <Form.Label className="f14-500 mb-1">Add Photos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadImage}
                        />
                      </div>
                      {file && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => setFile(null)}
                          >
                            <Image
                              src={require("../../../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <Image
                            src={file}
                            alt="icon"
                            title="icon"
                            className=""
                            fluid
                          />
                        </div>
                      )}
                    </div> */}
                        <hr />

                        <Form.Label className="f14-500 my-3">
                          Product Classification
                          <span style={{ color: 'black', fontWeight: 'bold' }}>
                            *
                          </span>
                        </Form.Label>
                        <div className="f10-500 opacity5 mb-3">
                          Select only one from the list this determine what
                          fields will be available while setting item within
                          this category
                        </div>
                        <Row>
                          {PRODUCTCLASSIFICATION.map((item, index) => (
                            <Col xs={6} md={4} key={index}>
                              <label className="enRadioWithText small f12-400 w-100 mb-3">
                                {item.title}
                                <input
                                  id="product_classification"
                                  type="radio"
                                  name="product_classification"
                                  value={item.title}
                                  onChange={() =>
                                    onChangeProductClassification(item)
                                  }
                                  checked={
                                    formik.values.product_classification ===
                                    item.title
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                          ))}
                        </Row>
                        {formik.errors.product_classification &&
                        formik.touched.product_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.product_classification}
                          </div>
                        ) : null}
                        <Form.Label className="f14-500 mb-3">
                          Global Classification
                          <span style={{ color: 'black', fontWeight: 'bold' }}>
                            *
                          </span>
                        </Form.Label>
                        <div className="d-flex align-items-center">
                          {/* <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Soups"
                            />

                            <span className="para-data-icon">Soups</span>
                          </div>
                        </div>
                      </div>
                      <div className="position-relative">
                        <div
                          className={
                            "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                          }
                        >
                          <div className="d-flex align-items-center">
                            <img
                              src={
                                "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                              }
                              alt="icon"
                              title="Starters"
                            />

                            <span className="para-data-icon">Starters</span>
                          </div>
                        </div>
                      </div> */}
                          <div className="mb-1 d-flex flex-wrap">
                            {props?.auth?.secondary_loader ? (
                              <div className="col-1 p-0 d-flex align-items-center">
                                <Loader
                                  type="ThreeDots"
                                  color="#00BFFF"
                                  height={39}
                                  width={39}
                                />
                              </div>
                            ) : (
                              // categoryClassification &&
                              //   categoryClassification
                              allCategoryClassifications &&
                              allCategoryClassifications.map((item, index) => (
                                <div
                                  className="enCheckWithText small"
                                  key={index}
                                >
                                  <input
                                    id="category_classification"
                                    type="radio"
                                    name="category_classification"
                                    value={item.title}
                                    onChange={formik.handleChange}
                                    checked={
                                      formik.values.category_classification ===
                                      item.title
                                    }
                                  />
                                  <label className="w-100 d-flex align-items-center justify-content-center">
                                    {item.title}
                                  </label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                        {formik.errors.category_classification &&
                        formik.touched.category_classification ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.category_classification}
                          </div>
                        ) : null}
                        <div
                          style={{ position: props.dash && 'relative' }}
                          className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5"
                        >
                          <div>
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Cancel"
                              buttonStyle={{ border: '1px solid' }}
                              // link="/casual-fine-dining/menusetup"
                              // link={
                              //   props.auth.user.VendorUser.has_admin_approved &&
                              //   props.auth.user.VendorUser
                              //     .have_vendor_submitted_details
                              //     ? "/categorydashboard"
                              //     : "/casual-fine-dining/menusetup"
                              // }
                              onClick={() => takeToDashboard()}
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger ml-3 mobile-btn-large"
                              buttonText="Next"
                              buttonType="button"
                              disabled={
                                allCategoryClassifications &&
                                allCategoryClassifications.length <= 0
                                  ? true
                                  : false
                              }
                              // buttonStyle={{ padding: "10px" }}
                              //onClick={() => handleNextStep(2)}
                              onClick={(e) => onClickNext(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {step === 2 && (
                      <React.Fragment>
                        <div className="nav-scroller mb-4">
                          <ul
                            className="enStepNav nav list-unstyled d-flex justify-content-between"
                            style={{ width: 300 }}
                          >
                            <li className="pho_24_medium done">
                              <div className="stepNumber">01</div>
                              <div className="text">Define Category</div>
                            </li>

                            <li className="doing">
                              <div className="stepNumber">02</div>
                              <div className="text">Taxes & Other Details</div>
                            </li>
                          </ul>
                        </div>
                        <div className="mb-4">
                          <TopTextReusableComponent
                            headingText={
                              props &&
                              props.activeCategoryData &&
                              props.activeCategoryData._id &&
                              props.activeCategoryData._id.length > 2
                                ? 'Edit Category'
                                : 'New Category'
                            }
                            headingParagraph="Manage your food items"
                          />
                        </div>
                        <Row>
                          <Col md={8}>
                            <NewInputText
                              labelText="Category Name"
                              extraClass="mb-3 w-100"
                              value={formik.values.name}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Form.Label className="f16-500 my-3">
                          Taxes & Other Charges
                        </Form.Label>
                        <Row className="align-items-center py-3">
                          <Col xs={6}>
                            <div className="f14-700">Price Includes Taxes</div>
                            <div className="f11-400 opacity5">
                              (Taxes are same for all the items in the category)
                            </div>
                          </Col>
                          <Col xs={6}>
                            <ToggleButtonWithYesNo
                              activeClass={WithTaxes}
                              checkedBox={WithTaxes}
                              onChange={handleWithTaxes}
                              disabled={
                                props.onboarding?.restaurantDetails?.pos
                                  ?.restId != ''
                                  ? true
                                  : false
                              }
                            />
                          </Col>
                        </Row>
                        <hr />

                        {/* WithTaxes === false */}
                        {WithTaxes ? (
                          <Fragment>
                            <div
                              className="d-flex align-items-center text-red f14-500 cursor my-4"
                              onClick={() => setShowAddedTaxes(!showAddedTaxes)}
                              //onClick={handleShowTaxSurcharges}
                            >
                              Show added Tax and Surcharges{' '}
                              <KeyboardArrowDownIcon />
                            </div>
                            {showAddedTaxes ? (
                              <Fragment>
                                {taxValues.map((item, index) => (
                                  <TaxesSurCharges
                                    // origin="main"
                                    changeHandle={(e, name) =>
                                      onChangeValue(e, name, item._id)
                                    }
                                    removeTax={() => removeTax(item)}
                                    key={index}
                                    tax_name={item.tax_name}
                                    curb_side={item.curb_side}
                                    take_away={item.take_away}
                                    dine_in_order={item.dine_in_order}
                                    skip_line={item.skip_line}
                                    catering_banquet={item.catering_banquet}
                                    home_delivery={item.home_delivery}
                                    tax_value={item.tax_value}
                                    orderingData={{
                                      take_away: { value: showTakeAway },
                                      skip_line: { value: showSkipTheLine },
                                      dine_in_order: { value: showDineIn },
                                      curb_side: { value: showCurbSide },
                                      catering_banquet: {
                                        value: showCateringBanquet,
                                      },
                                      home_delivery: {
                                        value: showHomeDelivery,
                                      },
                                      //                                      cubside_delivery: { value: false },
                                    }}
                                  />
                                ))}
                                {addNewTaxes.length > 0 ? (
                                  <Fragment>
                                    <div
                                      className="f14-400 mb-4 "
                                      style={{
                                        color: '#2096F3',
                                        cursor: 'pointer',
                                      }}
                                      onClick={openAddSurcharges}
                                    >
                                      Add/Maintain Tax/Surchages
                                    </div>
                                    <AddSurchargesModel
                                      //tax_value={item.tax_value}
                                      closeAddSurcharges={closeAddSurcharges}
                                      open={addsurcharges}
                                      taxInfo={addNewTaxes}
                                      take_away={showTakeAway}
                                      skip_line={showSkipTheLine}
                                      dine_in_order={showDineIn}
                                      curb_side={showCurbSide}
                                      catering_banquet={showCateringBanquet}
                                      home_delivery={showHomeDelivery}
                                      // cubside_delivery={showCurbSide}
                                      onClickSaveModalData={(data) =>
                                        onClickSaveModalData(data)
                                      }
                                    />
                                  </Fragment>
                                ) : (
                                  <> </>
                                )}
                              </Fragment>
                            ) : (
                              <> </>
                            )}
                          </Fragment>
                        ) : (
                          <Fragment></Fragment>
                        )}
                        <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                          <div>
                            <ReusableOnboardingButton
                              buttonTitle="Back Button"
                              buttonClass="btn-lg btn btn-outline-secondary"
                              buttonText="Back"
                              onClick={() => handleNextStep(1)}
                            />
                            <ReusableOnboardingButton
                              buttonTitle="Next Button"
                              buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                              buttonText="Save"
                              buttonType="button"
                              onClick={(e) => onClickSave(e)}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </Form>
                </div>
              </div>
              {!props.dash && (
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                  <SliderReusableComponent
                    displayHamburger={true}
                    headingText={'Menu Set Up - Categories'}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require('../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg')}
                  />
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
};

AddCategories.propTypes = {
  auth: PropTypes.object.isRequired,
  add_category_menu_setup: PropTypes.func.isRequired,
  edit_category_menu_setup: PropTypes.func.isRequired,
  update_ordering_subscription_taxes: PropTypes.func.isRequired,
  ActiveMenu: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding,
  categoryClassification: state?.category?.category_classification,
  get_catgory_Classification: state?.onboarding?.get_menu_setup_category_all,
  activeCategoryData: state.onboarding && state.onboarding.activeCategoryData,
  servicesEnabled:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  servicesEnabledFastFood:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering,
  servicesEnabledMultiService:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details
      .multi_service_business_status &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .ordering,
  // checkSkipLine:
  //   state.onboarding && state.onboarding.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering
      .order_general,
  subscriptionDataFastFood:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering &&
    state.onboarding.onboard_subscription_details.fast_food_dining_status
      .ordering.order_general,
  subscriptionDataMultiServices:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details
      .multi_service_business_status &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .ordering &&
    state.onboarding.onboard_subscription_details.multi_service_business_status
      .ordering.order_general,

  orderingTaxesData: state?.onboarding?.onboard_subscription_details
    ?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.ordering?.order_general
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.ordering?.order_general
    : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering?.order_general,
  serviceType:
    state.onboarding && state.onboarding.onboard_subscription_details,
  ActiveMenu: state?.onboarding?.active_menu,
});

export default connect(mapStateToProps, {
  get_all_subcategoryIn_menuSetup,
  add_category_menu_setup,
  edit_category_menu_setup,
  update_ordering_subscription_taxes,
})(AddCategories);
//
